// extracted by mini-css-extract-plugin
export default {"header":"NotificationHeader_header__48Xy4"};